import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const soloParentingMontessori: BlogMetaData = {
  title: 'ワンオペ育児が辛い・ノイローゼになりそう…モンテッソーリ流「自立を促す5つの工夫」で楽になる方法',
  description:
    'ワンオペ育児ノイローゼのサインや限界を感じている方へ。モンテッソーリ教育の「子どもの自立を促す環境づくり」で今日から楽になる方法を解説。お風呂タイムの乗り切り方、1人でできる時短モンテ活動、年齢別ガイド、外部サービス活用まで網羅した完全版。',
  thumbnailUrl: '/img/blog-solo-parenting-montessori.png',
  filePath: buildBlogFilePath('solo-parenting-montessori'),
  category: BLOG_CATEGORY.PARENTING,
};
